import Mixin from "../../mixin.js";
import Funnel from "../../services/funnel-service.js";
const template = `
    <div class="grid " v-show="fs.display(input)">
        <ul  :class="gridClass" role="radiogroup" :aria-labelledby="input.id + '_label'">
            <li class="data-card-radio" v-for="(item, index) in items" :key="index" :uid="input.uid">
                <input type="radio"
                    :uid="input.uid+ '_option_' + index"
                    :id="input.id + '_option_' + index"
                    :required="input.validation.required"
                    :name="input.element_name"
                    :checked="setChecked(item)"
                    @change="exec($event, input)"
                    :value="item.value"
                    :disabled="setDisabled(item.disabled)"
                    :data-uid="input.uid"
                    :aria-labelledby="input.id + '_option_' + index + '_label'"
                />

                <label :for="input.id + '_option_' + index" class="button-radio data-card-radio-label" :id="input.id + '_option_' + index + '_label'">
                    <div class="grid">
                        <div v-for="optData in item.data" :class="'s12 clm twin-button-excerpt ' + item.class">
                            <span class="card-section-title">{{optData.field}}:</span>
                            <span class="card-section-value">{{optData.value}}</span>
                        </div>
                    </div>
                </label>
            </li>
        </ul>
        <div class="error-here" role="alert" aria-live="assertive"></div>
        <input
            :uid="input.uid+ '_hidden_'"
            type="hidden"
            :id="input.id"
            :required="input.validation.required"
            :name="input.element_name"
            :value="input.value"
        />
</div>
`;


export default {
    name: 'b-data-card-radio',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        items: function () {
            //need to look for places where this is needed and implement this method
            return {... this.input.options};
        },
        radio_count: function () {
            var count = 0;
            var options = this.input.options
            if (options.length > 0) {
                options.forEach(function (option) {
                    count++;
                });
            }
            if (count === 2) {
                var offset = 'm6 l4 m-offset-3 l-offset-4'
            } else if (count === 3) {
                var offset = 'm12 m-offset-1'
            } else if (count === 4) {
                var offset = 'm12'
            } else if (count === 5) {
                var offset = 'm12'
            }

            return offset;
        },
        // gridClass: function(){
        //     console.log(Object.keys(this.items).length);
        //     if (Object.keys(this.items).length >= 4) {
        //         return 'block-grid-m4'
        //     }
        //     else{
        //          return 'block-grid-m'+ Object.keys(this.items).length
        //     }

        // },
        gridClass: function(){
            var self = this
            var total_items = Object.keys(this.items).length

            
            if (this.input.grid_class) {
                var grid_size = this.input.grid_class
                var grid = "block-grid-s1 block-grid-m"+ grid_size
                return grid;
            }

            if (total_items <= 2 ) {

                var grid_size = 2
                var grid = "block-grid-s1 block-grid-m"+ (grid_size) + " block-grid-l"+ grid_size
                return grid;
            }

            else if (total_items >= 3 ) {

                var grid_size = 2
                var grid = "block-grid-s1 block-grid-m"+ (grid_size) + " block-grid-l"+ grid_size
                return grid;
            }

        },

    },
    methods: {
        setChecked(item) {
            return this.input.value == item.value;
        }
    }
};
